(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.OnFarmStorageController = (function(superClass) {
    extend(OnFarmStorageController, superClass);

    function OnFarmStorageController(scope, transitions, state, modal, service, loading, q) {
      var ref, ref1;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.modal = modal;
      this.service = service;
      this.loading = loading;
      this.q = q;
      OnFarmStorageController.__super__.constructor.apply(this, arguments);
      if ((ref = App.sidebar) != null) {
        ref.close();
      }
      if ((ref1 = App.angularSidebar) != null) {
        ref1.close();
      }
      this.scope.title = 'OFS Inspections and Estimates';
      this.scope.fullpage = true;
      this.scope.alwaysReenable = true;
      this.filters = {};
      this.users = [];
      this.contracts = [];
      this.bins = [];
      this.measurement = new this.service.Measurement;
      this.service.getYears().then((function(_this) {
        return function(years) {
          _this.years = years;
          _this.filters.year = years[0];
          return _this.onYearChange();
        };
      })(this));
      this.scope.save = (function(_this) {
        return function() {
          var bin, fn, i, len, promises, ref2;
          _this.clearAlert();
          promises = [];
          ref2 = _this.bins;
          fn = function(bin) {
            var promise;
            promise = _this.service.saveBinId(_this.filters.year, bin).then(function(data) {
              bin.unUnique = false;
              return data;
            })["catch"](function(err) {
              bin.unUnique = true;
              return _this.q.reject(err);
            });
            return promises.push(promise);
          };
          for (i = 0, len = ref2.length; i < len; i++) {
            bin = ref2[i];
            fn(bin);
          }
          if ((_this.measurement.measured_pounds != null) || (_this.measurement.measurement_date != null)) {
            if (_this.measurement.id != null) {
              promises.push(_this.measurement.$update());
            } else {
              promises.push(_this.measurement.$save());
            }
          }
          return _this.q.all(promises).then(function(all) {
            return _this.setAlert({
              type: 'success',
              msg: 'Saved successfully'
            });
          })["catch"](function(err) {
            var msgs;
            msgs = [];
            if (err.data.measured_pounds != null) {
              msgs = msgs.concat(err.data.measured_pounds);
            }
            if (err.data.measurement_date != null) {
              msgs = msgs.concat(err.data.measurement_date);
            }
            if (err.data.binId != null) {
              msgs = msgs.concat(err.data.binId);
            }
            if (msgs.length) {
              return _this.setAlert({
                type: 'error',
                msg: 'Validation Errors'
              }, msgs);
            } else {
              throw err;
            }
          });
        };
      })(this);
    }

    OnFarmStorageController.prototype.editBin = function(bin) {
      var original;
      original = angular.copy(bin);
      return this.modal.open({
        windowClass: 'larger_dialog',
        templateUrl: 'backend/portal/on-farm-storage/bin-details-layout',
        controller: 'BinDetailsController',
        controllerAs: 'bdc',
        resolve: {
          bin: function() {
            return bin;
          },
          noSave: function() {
            return false;
          }
        }
      }).result.then((function(_this) {
        return function() {
          return _this.loadBins();
        };
      })(this))["catch"](function() {
        return angular.copy(original, bin);
      });
    };

    OnFarmStorageController.prototype.editInspection = function(bin) {
      var original;
      original = angular.copy(bin.inspection);
      return this.modal.open({
        windowClass: 'larger_dialog',
        templateUrl: 'backend/portal/on-farm-storage/inspection-layout',
        controller: 'OnFarmStorage.Controllers.BinInspectionsController',
        controllerAs: 'bic',
        resolve: {
          bin: function() {
            return bin;
          },
          year: (function(_this) {
            return function() {
              return _this.filters.year;
            };
          })(this)
        }
      }).result.then(function() {
        return bin.noInspection = false;
      })["catch"](function() {
        return angular.copy(original, bin.inspection);
      });
    };

    OnFarmStorageController.prototype.onYearChange = function() {
      this.filters.user = null;
      this.filters.contract = null;
      this.users = [];
      this.contracts = [];
      this.bins = [];
      return this.service.getUsers(this.filters.year).then((function(_this) {
        return function(users) {
          return _this.users = users;
        };
      })(this));
    };

    OnFarmStorageController.prototype.onUserChange = function() {
      this.filters.contract = null;
      this.filters.bin = null;
      this.contracts = [];
      this.bins = [];
      this.loadContracts();
      return this.loadBins();
    };

    OnFarmStorageController.prototype.loadContracts = function() {
      var contractsLoading;
      contractsLoading = this.loading.overCustom('#ofs-contracts', 'Loading...');
      return this.service.getContracts(this.filters.year, this.filters.user).then((function(_this) {
        return function(contracts) {
          _this.contracts = contracts;
          return contractsLoading.hide();
        };
      })(this));
    };

    OnFarmStorageController.prototype.loadBins = function() {
      var binsLoading;
      binsLoading = this.loading.overCustom('#ofs-bins', 'Loading...');
      return this.service.getBins(this.filters.user).then((function(_this) {
        return function(bins) {
          var bin, fn, i, len;
          fn = function(bin) {
            _this.service.getBinId(_this.filters.year, bin.id).then(function(binId) {
              return bin.bin_id = binId;
            });
            return _this.service.BinInspection.query({
              binId: bin.id,
              year: _this.filters.year
            }).$promise.then(function(inspections) {
              if (inspections.length) {
                return bin.inspection = inspections[0];
              } else {
                return bin.noInspection = true;
              }
            });
          };
          for (i = 0, len = bins.length; i < len; i++) {
            bin = bins[i];
            fn(bin);
          }
          _this.bins = bins;
          return binsLoading.hide();
        };
      })(this));
    };


    /*
     * Step 1
     * Select contract. If already selected, deselect
     * If a bin is selected, deselect
     */

    OnFarmStorageController.prototype.onContractClick = function(contract, bin) {
      this.filters.contract = this.filters.contract === contract ? null : contract;
      this.filters.bin = this.filters.bin === bin ? null : void 0;
      return this.measurement = new this.service.Measurement;
    };


    /*
     * Step 2
     * Select bin. If already selected, deselect
     */

    OnFarmStorageController.prototype.onBinClick = function(bin, $event) {
      if ($event.target.nodeName === 'INPUT' || $event.target.nodeName === 'BUTTON') {
        return;
      }
      this.filters.bin = this.filters.bin === bin ? null : bin;
      return this._loadMeasurement(this.filters.contract, this.filters.bin);
    };

    OnFarmStorageController.prototype._loadMeasurement = function(contract, bin) {
      var measurementLoading;
      if (!((contract != null) && (bin != null))) {
        return;
      }
      measurementLoading = this.loading.overCustom('#ofs-measurement-details', 'Loading...');
      return this.service.getMeasurementId(contract, bin).then((function(_this) {
        return function(measurementId) {
          return _this.service.Measurement.get({
            id: measurementId
          }).$promise.then(function(measurement) {
            _this.measurement = measurement;
            _this.measurement.storage_locations_id = bin.id;
            _this.measurement.contracts_id = contract.id;
            return measurementLoading.hide();
          });
        };
      })(this))["catch"]((function(_this) {
        return function() {
          _this.measurement = new _this.service.Measurement({
            storage_locations_id: bin.id,
            contracts_id: contract.id
          });
          return measurementLoading.hide();
        };
      })(this));
    };

    return OnFarmStorageController;

  })(Controller);

}).call(this);
